import { render, staticRenderFns } from "./response-modal.vue?vue&type=template&id=67a24a4c&scoped=true&"
import script from "./response-modal.vue?vue&type=script&lang=js&"
export * from "./response-modal.vue?vue&type=script&lang=js&"
import style0 from "./response-modal.vue?vue&type=style&index=0&id=67a24a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a24a4c",
  null
  
)

export default component.exports